export default "/images/vendor/intl-tel-input/build/globe@2x.webp?5dc7e51d6b5d42fc2be450b5e5e1c54d";